import React from "react";
import { TypeAnimation } from "react-type-animation";
import { BankAccount } from "../../domain/types/banks/BankAccount";

interface BankNameLoaderProps {
  bank: BankAccount | undefined;
}

const BankNameLoader: React.FC<BankNameLoaderProps> = ({ bank }) => {
  console.debug("BankNameLoader: Bank: ", bank);
  if (bank) {
    return (
      <span className="font-medium">
        {bank.name} - {bank.mask}
      </span>
    );
  } else {
    return (
      <span className="font-medium text-gray-500">
        Fetching bank name{" "}
        <TypeAnimation
          sequence={[
            ".",
            1000,
            "..",
            1000,
            "...",
            1000,
            "..",
            1000,
            ".",
            1000,
            "",
            500,
          ]}
          wrapper="span"
          repeat={Infinity}
          className="inline-block"
        />
      </span>
    );
  }
};

export default BankNameLoader;
